export class ClassNameRequestModel {
    className: string;
    constructor(className: string) {
        this.className = className;
    }
}